import { ModelBase } from '@framework/models/base/base.model';
import { UserContextModel } from '../../auth-models';

export class LoginFacebookOutputApiModel extends ModelBase {
    public userContext: UserContextModel;
    constructor(init?: Partial<LoginFacebookOutputApiModel>) {
        super(init);
        Object.assign(this, init);
    }
}